<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择" style="width: 130px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-date-picker v-model="formDatas.acrYearMonthExchange" type="month" value-format="yyyyMM"
                        placeholder="核销时间" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.acrYearMonth" type="month" value-format="yyyyMM"
                        placeholder="制卡时间" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.dateStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="制卡开始时间" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.dateEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="制卡结束时间" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.dateCheckStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="核销开始时间" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.dateCheckEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="核销结束时间" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-input v-model="formDatas.acrAmount" style="width: 120px;" size="mini" placeholder="卡劵金额"
                        clearable></el-input>
                    <el-input v-model="formDatas.acrCode" style="width: 120px;" size="mini" placeholder="卡劵号码"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.acrCodeType" clearable @change="partserch"
                        placeholder="请选择劵码类型" style="width: 130px">
                        <el-option label="普通" :value="1"></el-option>
                        <el-option label="烟感" :value="2"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.acrStatus" clearable @change="partserch" placeholder="请选择"
                        style="width: 130px">
                        <el-option label="分账" :value="5"></el-option>
                        <el-option label="退款" :value="6"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="acrId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑卡劵' : '新增卡劵'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="卡劵规格" prop="acrrxId">
                                <el-select v-model="form.acrrxId" filterable clearable placeholder="请选择"
                                    style="width: 80%;">
                                    <el-option
                                        v-for="(item, index) in getAjefCertificateRecordRelationXiaoxiangList_data"
                                        :key="index" :label="item.acrAmount + '元'" :value="item.acrrxId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="生成数量" prop="number">
                                <el-input type="number" v-model="form.number" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <el-dialog title="烟感卡劵核销详情" :visible.sync="diaDetail" width="60%">
                <el-table :data="tableDataDetail" stripe border style="width: 100%" :max-height="400"
                    :cell-style="{ textAlign: 'center' }" :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none',
                    }">
                    <el-table-column prop="userName" label="用户姓名" width="200">
                    </el-table-column>
                    <el-table-column prop="userPhone" label="用户手机号" width="200">
                    </el-table-column>
                    <el-table-column prop="userAddress" label="用户地址" >
                    </el-table-column>
                    <el-table-column prop="userState" label="同步状态" width="150">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    scope.row.userState == 1 ? '未同步' :
                                        scope.row.userState == 2 ? '已同步' : ''
                                }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="diaDetail = false">取 消</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefCertificateRecordExpandDetectorList, getAjefCertificateRecordRelationXiaoxiangList, getAjefShopListQuick, getAjefCertificateStatisticsCheckList, addAjefCertificateRecordMulti, updateAjefShop, cancelAjefCertificateRecordMulti, getAjefCertificateRecordStatisticsYear } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getAjefCertificateRecordRelationXiaoxiangList_data: [],
            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'acrId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acrYearMonth",
                    key: "acrYearMonth",
                    title: "制卡月份",
                    align: "center",
                    fixed: 'left',
                    width: 90,
                },

                {
                    field: "acrYearMonthExchange",
                    key: "acrYearMonthExchange",
                    title: "核销月份",
                    align: "center",
                    fixed: 'left',
                    width: 90,
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    fixed: 'left',
                    width: 200,
                },
                {
                    field: "asNumber",
                    key: "asNumber",
                    title: "商户编码",
                    align: "center",
                    fixed: 'left',
                    width: 90,
                },
                {
                    field: "acrAmount",
                    key: "acrAmount",
                    title: "卡劵金额",
                    fixed: 'left',
                    align: "center",
                    width: 100,
                },
                // {
                //     field: "specificationXiaoxiang",
                //     key: "specificationXiaoxiang",
                //     title: "小象规格id",
                //     fixed: 'left',
                //     align: "center",
                //     width: 120,
                // },
                {
                    field: "acrCode",
                    key: "acrCode",
                    title: "卡劵号码",
                    align: "center",
                    width: 250,
                },
                {
                    field: "acrCodeType",
                    key: "acrCodeType",
                    title: "劵码类型",
                    align: "center",
                    width: 140,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acrCodeType == 1 ? '普通' :
                                        row.acrCodeType == 2 ? '烟感' : ''
                                }
                                {
                                    row.acrCodeType == 2 ? <el-button type="text" size="mini" style="margin-left: 10px" on-click={() => this.showDetail(row)}>附加信息</el-button> : ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "acrExchangeDes",
                    key: "acrExchangeDes",
                    title: "核销备注",
                    align: "center",
                    width: 180,
                },
                {
                    field: "acrExchangeRatio",
                    key: "acrExchangeRatio",
                    title: "核销分账比例(10000%)",
                    align: "center",
                    width: 120,
                },
                {
                    field: "acrExchangeShop",
                    key: "acrExchangeShop",
                    title: "商铺分账金额(1000/分)",
                    align: "center",
                    width: 120,
                },
                {
                    field: "acrExchangeTime",
                    key: "acrExchangeTime",
                    title: "核销时间",
                    align: "center",
                    width: 160,
                },
                {
                    field: "acrExchangeUserName",
                    key: "acrExchangeUserName",
                    title: "核销用户",
                    align: "center",
                    width: 120,
                },
                {
                    field: "acrExchangeImages",
                    key: "acrExchangeImages",
                    title: "卡劵核销实物截图",
                    align: "center",
                    width: 160,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                     {
                                        //查看详情
                                        row.acrExchangeImages ?  <el-button type="text" size="mini" style="margin-left: 10px;"
                                            onClick={() => this.$emit('child-call', row.acrExchangeImages.split(','))}>查看详情</el-button> : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "acrStatus",
                    key: "acrStatus",
                    title: "状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acrStatus == 0 ? <el-tag size="mini" type="info">已撤销</el-tag> :
                                        row.acrStatus == 1 ? <el-tag size="mini" type="warning">创建</el-tag> :
                                            row.acrStatus == 2 ? <el-tag size="mini" >第三方导入</el-tag> :
                                                row.acrStatus == 3 ? <el-tag size="mini" >第三方领取</el-tag> :
                                                    row.acrStatus == 4 ? <el-tag size="mini" type="success">已核销</el-tag> : row.acrStatus == 5 ? <el-tag size="mini" type="success">分账</el-tag> : <el-tag type="danger" size="mini">退款</el-tag>
                                }
                            </span>
                        );
                    },
                },

                // { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
        getAjefCertificateRecordRelationXiaoxiangList({ pageSize: 0 }).then(res => {
            this.getAjefCertificateRecordRelationXiaoxiangList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        showDetail(row) {
            this.openLoading()
            getAjefCertificateRecordExpandDetectorList({ asId: row.asId, acrCode: row.acrCode }).then(res => {
                this.loadings.close()
                this.tableDataDetail = res.data
                this.diaDetail = true
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-statistics-check/exportAjefCertificateStatisticsCheck',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '核销统计.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ acrId: this.theRow.acrId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        cancelAjefCertificateRecordMulti({ acrIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    cancelAjefCertificateRecordMulti({ acrIds: row.acrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefCertificateRecordMulti(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShop(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acrId = row.acrId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjefCertificateStatisticsCheckList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefCertificateStatisticsCheckList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjefCertificateStatisticsCheckList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>